import { login, logout, checkToken, setLoginDate, getLoginDate, getSelectableMonth, getSelectableMonthToNow } from '@/api/user';
import { employeeFind } from '@/api/authority/employee'
import { getToken, setToken, removeToken } from '@/utils/auth';
import router, { resetRouter } from '@/router';
import { getCurrentAccountSet, removeCurrentAccountSet } from '@/api/accountSet';

const state = {
  token: getToken(),
  expireDate: null,
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  user: null,
  authority: null,
  loginDate: getLoginDate(),
  assistVisible: null,
  // 可选日期 账簿与核对总账模块需要
  selectableMonth: getSelectableMonth,
  selectableMonthToNow: getSelectableMonthToNow
};

const mutations = {
  SET_ASSIST_VISIBLE: (state, assistVisible) => {
    state.assistVisible = assistVisible;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_EXPIRE_DATE: (state, expireDate) => {
    state.expireDate = expireDate;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
  SET_AUTHORITY: (state, authorityList) => {
    state.authority = authorityList.reduce((result, item)=>{
      if (item.enable){
        result[item.code] = true;
      }
      return result;
    }, {});
  },
  SET_LOGINDATE: (state, loginDate) => {
    state.loginDate = loginDate;
  }
};

const actions = {
  // user login
  login ({ commit }, userInfo) {
    const { username, password, employeeaccount, loginDate } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, employeeaccount })
        .then(response => {
          const { data } = response;
          commit('SET_TOKEN', data.token);
          commit('SET_LOGINDATE', loginDate);
          if (data.vipStatus != 1) {
            commit('SET_EXPIRE_DATE', data.expireDate);
          }
          // 时间保存到本地
          setLoginDate(loginDate);
          setToken(data.token);
          removeCurrentAccountSet();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // get user info
  async getInfo ({ commit, state }) {
    const response = await checkToken();
    const { user, cashierName, assist } = response.data;

    if (!user) {
      throw 'Verification failed, please Login again.';
    }

    if (cashierName) {
      user.cashier_name = cashierName;
    }

    commit('SET_USER', user);
    commit('SET_ASSIST_VISIBLE', !!assist);

    const response2 = await employeeFind();
    commit('SET_AUTHORITY', response2.data.list || []);
    return  user;
  },

  // user logout
  logout ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          commit('SET_USER', null);
          removeToken();
          resetRouter();

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch('tagsView/delAllViews', null, { root: true });
          removeCurrentAccountSet();
          window._reportSDK.setUserId(-1);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },

  // dynamically modify permissions
  changeRoles ({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token';

      commit('SET_TOKEN', token);
      setToken(token);

      const { roles } = await dispatch('getInfo');

      resetRouter();

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true });

      // dynamically add accessible routes
      router.addRoutes(accessRoutes);

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true });

      resolve();
    });
  },

  checkLogin ({ state, dispatch }) {
    return new Promise(async resolve => {
      if (state.user !== null) {
        resolve(true)
        return
      }
      try {
        await dispatch('getInfo');
        resolve(true)
      } catch (error) {
        console.log(error)
        resolve(false)
      }
    })
  },
  checkAccountSet({ state, dispatch }) {
    return new Promise(async resolve => {
      if (getCurrentAccountSet()) {
        resolve(true);
      }
      else {
        resolve(false)
      }
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
